<template>
  <section class="charts">
    <vue-highcharts
      :highcharts="Highcharts"
      :options="barOptions"
      ref="drilldownChart"
    ></vue-highcharts>
  </section>
</template>
<script>
import VueHighcharts from "vue2-highcharts";
import Highcharts from "highcharts";

export default {
  name: "chart",
  props: ["data"],
  components: {
    VueHighcharts,
  },
  data() {
    return {
      Highcharts: Highcharts,
      barOptions: {},
    };
  },
  watch: {
    data: function () {
      this.renderChart();
    },
  },
  created() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      this.barOptions = {
        lang: {
          drillUpText: "back",
        },
        chart: {
          type: "column",
          backgroundColor: "transparent",
          height: 170,
          style: {
            fontFamily: '"Open Sans"',
          },
        },
        title: {
          text: "",
        },
        xAxis: {
          type: "category",
          title: {
            text: "",
          },
          labels: {
            style: {
              color: "#fff",
              fontSize: "12px",
              fontWeight: 600,
              textDecoration: "none",
              opacity: 0.5,
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
          gridLineDashStyle: "longdash",
          gridLineWidth: 1,
          labels: {
            style: {
              color: "#fff",
              fontSize: "12px",
              fontWeight: 600,
              textDecoration: "none",
              opacity: 0.5,
            },
          },
        },
        tooltip: {
          valueSuffix: "",
          shared: false,
          enabled: true,
          pointFormat:"{point.y:.0f}",
          headerFormat: "",
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            borderRadius: 2,
            dataLabels: {
              enabled: false,
            },
          },
        },
        colors: ["#F5A623"],
        series: [
          {
            name: "Chart Data",
            colorByPoint: false,
            data: this.data,
          },
        ],
      };
    },
  },
};
</script>
<style>
.charts {
  height: 100%;
}
.highcharts-yaxis-grid .highcharts-grid-line {
  stroke-width: 0.5px;
  stroke: rgba(255, 255, 255, 0.1);
}
.highcharts-xaxis .highcharts-axis-line {
  display: none;
}
</style>
